module.exports = __webpack_public_path__ + "static/media/ic_arrow_left.623c4b59.svg";